/* eslint-disable prefer-rest-params */
/* eslint-disable func-names */
import EDC from './globals';
import { Menu } from './menu';
import router from '../../../router/index';
/**
 *
 */
EDC.UI.IngameMenu = function () {
  Menu.apply(this, arguments);
};
/**
 *
 */
EDC.UI.IngameMenu.prototype = Object.create(Menu.prototype);
EDC.UI.IngameMenu.prototype.constructor = EDC.UI.IngameMenu;
/**
 *
 */
EDC.UI.IngameMenu.prototype.create = function () {
  Menu.prototype.create.apply(this, arguments);
  this.addButtons();
};
/**
 *
 */
EDC.UI.IngameMenu.prototype.addButtons = function () {
  /*
    this.addButton("continue", this.onContinue.bind(this));
    this.addButton("parent", this.onParentSite.bind(this));
    this.addButton("exit", this.onExit.bind(this), null, null, 130);
    */
};
/**
 *
 */
EDC.UI.IngameMenu.prototype.onContinue = function () {
  this.hide();
};
/**
 *
 */
EDC.UI.IngameMenu.prototype.onParentSite = function () {
  window.location = 'https://growmindgrow.com';
};
/**
 *
 */
EDC.UI.IngameMenu.prototype.onExit = function () {
  router.push({ name: 'main-menu' });
};

export default EDC.UI.IngameMenu;
